/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Empty_TitleInputs */

const es_components_file_tree_empty_title = /** @type {(inputs: Components_File_Tree_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carpeta está vacía`)
};

const en_components_file_tree_empty_title = /** @type {(inputs: Components_File_Tree_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder is empty`)
};

/**
* | output |
* | --- |
* | "This folder is empty" |
*
* @param {Components_File_Tree_Empty_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_empty_title = /** @type {((inputs?: Components_File_Tree_Empty_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Empty_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_empty_title(inputs)
	return en_components_file_tree_empty_title(inputs)
});
export { components_file_tree_empty_title as "components.file_tree.empty_title" }